export const extractSearchParams = () => {
  const querystring = globalThis.location.search;
  const searchParams = new URLSearchParams(querystring);
  const searchParamsObject = Object.fromEntries(searchParams);
  return searchParamsObject;
};

export const formatUrl = (url: string): string => {
  if (!url || url === '' || url.includes('http://') || url.includes('https://')) return url;

  return `https://${url}`;
};
